var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skin-toolbox"},[_c('div',{staticClass:"panel-body"},[_c('h4',[_vm._v("主题颜色")]),_vm._v(" "),_c('NavBarBox',{attrs:{"theme":_vm.theme},on:{"onChange":_vm.onChangeTheme}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4888fd50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/SkinToolbox/index.vue
// module id = null
// module chunks = 